module.exports = __webpack_public_path__ + "img/h_dog_pt_setsku.prt.da457eb5.jpg";